import type { DropdownColumn } from './Desktop/NavDropdown';

export type NavItem = {
  label: string;
  columns: DropdownColumn[];
};

export const navigation: NavItem[] = [
  {
    label: 'For Business',
    columns: [
      {
        title: 'Manufacturing for construction',
        description: 'Custom solutions for manufacturers in construction',
        links: [
          {
            label: 'MindPal ConTech',
            href: 'https://construction.mindpal.co',
            linkType: 'external',
          },
        ],
      },
      {
        title: 'Recruitment',
        description: 'Automate and simplify hiring.',
        links: [
          {
            label: 'HR Recruitment',
            href: '/recruiter',
            linkType: 'internal',
          },
          {
            label: 'Blue Collar Recruitment',
            href: '/ai-blue-collar',
            linkType: 'internal',
          },
        ],
      },
    ],
  },
  {
    label: 'For Individuals',
    columns: [
      {
        title: 'For Jobseekers',
        description: 'Get Job Matches in minutes with intelligent AI matching.',
        links: [
          {
            label: 'Our products',
            href: '/resume-checker',
            linkType: 'internal',
          },
        ],
      },
    ],
  },
  {
    label: 'Solutions',
    columns: [
      {
        title: 'For Business - Manufacturing',
        description: 'Tools to automate quoting and production.',
        links: [
          {
            label: 'CNC Instant Quote',
            href: '/cnc-rfq',
            linkType: 'internal',
          },
        ],
      },
      {
        title: 'For Business - Recruitment',
        description: 'Automate and simplify hiring.',
        links: [
          { label: 'Resume Generator', href: '/resume', linkType: 'internal' },
          {
            label: 'Job Matching',
            href: '/job-matching',
            linkType: 'internal',
          },
          { label: 'MindPal ATS', href: '/ats', linkType: 'internal' },
          {
            label: 'Pricing',
            href: '/pricing/recruiter',
            linkType: 'internal',
          },
          {
            label: 'Go to App',
            href: '/dashboard',
            linkType: 'internal',
            style: 'app' as const,
          },
        ],
      },
      {
        title: 'For Individuals',
        description: 'Get Job Matches in minutes with intelligent AI matching.',
        links: [
          {
            label: 'Resume Checker',
            href: '/resume-checker',
            linkType: 'internal',
          },
          {
            label: 'Bullet Points Generator',
            href: '/bullet-points',
            linkType: 'internal',
          },
          {
            label: 'Pricing',
            href: '/pricing/candidate',
            linkType: 'internal',
          },
          {
            label: 'Go to Job Board',
            href: '/jobs',
            linkType: 'internal',
            style: 'app' as const,
          },
          {
            label: 'Go to App',
            href: '/builder',
            linkType: 'internal',
            style: 'app' as const,
          },
        ],
      },
    ],
  },
  {
    label: 'Company',
    columns: [
      {
        title: 'About MindPal',
        description: 'Latest updates, events, and ideas',
        links: [
          { label: 'About Us', href: '/about-us', linkType: 'internal' },
          {
            label: 'Success Stories',
            href: '/success-stories',
            linkType: 'internal',
          },
          {
            label: 'Case Studies',
            href: '/case-studies',
            linkType: 'internal',
          },
          { label: 'Services', href: '/services', linkType: 'internal' },
          {
            label: 'Privacy Policy',
            href: '/privacy-policy',
            linkType: 'internal',
          },
          {
            label: 'Cookie Policy',
            href: '/cookie-policy',
            linkType: 'internal',
          },
          {
            label: 'Terms of Service',
            href: '/terms-of-service',
            linkType: 'internal',
          },
          {
            label: 'Responsible Disclosure',
            href: '/responsible-disclosure',
            linkType: 'internal',
          },
          { label: 'SMS Terms', href: '/sms-terms', linkType: 'internal' },
        ],
      },
      {
        title: 'Insights',
        description: 'Latest updates, events, and ideas',
        links: [
          {
            label: 'Press releases',
            href: '/press-room',
            linkType: 'internal',
          },
          {
            label: 'Manufacturing Webinars',
            href: 'https://construction.mindpal.co/webinar',
            linkType: 'external',
          },
          {
            label: 'Career Guides',
            href: '/career-guides',
            linkType: 'internal',
          },
          { label: 'Blog', href: '/ai-company', linkType: 'internal' },
          {
            label: 'Manufacturing Blog',
            href: '/manufacturing-blog',
            linkType: 'internal',
          },
        ],
      },
    ],
  },
];
